import { services } from '@octadesk-tech/services'
import store from '@/store'

import { getParameterHeaders } from './headers'

export const getFluxes = () =>
  services
    .createClient('widgetBff')
    .then(client =>
      client.get('flux', {
        params: {
          sd: store.getters.company
        }
      })
    )
    .then(res => (res.data || []).filter(f => f.enabled))

export const getFlux = fluxId =>
  services
    .createClient('widgetBff')
    .then(client =>
      client.get(`flux/${fluxId}`, {
        params: {
          sd: store.getters.company
        }
      })
    )
    .then(res => res.data)

export const fluxStatistics = fluxId => ({
  path: `flux/${fluxId}/statistics`,
  sended(params = '') {
    return services
      .createClient('widgetBff')
      .then(client =>
        client.put(`${this.path}/sended${params}`, undefined, {
          headers: getParameterHeaders()
        })
      )
      .then(res => res.data)
  },
  opened(params = '') {
    return services
      .createClient('widgetBff')
      .then(client =>
        client.put(`${this.path}/opened${params}`, undefined, {
          headers: getParameterHeaders()
        })
      )
      .then(res => res.data)
  },
  contactsNew(params = '') {
    return services
      .createClient('widgetBff')
      .then(client =>
        client.put(`${this.path}/contacts/new${params}`, undefined, {
          headers: getParameterHeaders()
        })
      )
      .then(res => res.data)
  },
  contactsExistent(params = '') {
    return services
      .createClient('widgetBff')
      .then(client =>
        client.put(`${this.path}/contacts/existent${params}`, undefined, {
          headers: getParameterHeaders()
        })
      )
      .then(res => res.data)
  }
})
